export const PLATFORMS = [
  { key: 'leetcode', label: 'LeetCode', enabled: true },
  { key: 'codeforces', label: 'Codeforces', enabled: false },
  { key: 'codechef', label: 'CodeChef', enabled: false },
];
